<ea-modal
    [size]="MODAL_SIZES.Large"
    [modalId]="constants.modalIds.EXPLORATION_SURVEY_MODAL"
    [title]="explorationSurveyTitle || 'Exploration Survey'"
    [clickOutsideClose]="true">
    <ng-template #modalBody>
        @if (explorationSurveyDescription) {
            <ea-paragraph>
                <div [innerHTML]="explorationSurveyDescription"></div>
            </ea-paragraph>
        }
        <div class="d-flex padding-2 margin-top-2">
            @for (survey of explorationSurvey; track survey; let i = $index) {
                <div class="col-4 text-center">
                    <img
                        [src]="cdnUrl + '/' + survey.filePath"
                        [alt]="survey.name"
                        class="jump-start-survey-images tw-object-fill"
                        (click)="handleSurveyImageClick(survey)"
                    />
                    <ea-paragraph>
                        <span [innerHTML]="survey.data"></span>
                    </ea-paragraph>
                </div>
            }
        </div>
    </ng-template>
</ea-modal>

<ea-modal
	[size]="MODAL_SIZES.Large"
	[modalId]="constants.modalIds.EXPLORATION_EXTERNAL_SURVEY"
	[title]="constants.EXTERNAL_LINK_MODAL.TITLE"
	[clickOutsideClose]="false">
		<ng-template #modalBody>
			<ea-paragraph data-cy="survey-external-navigation-modal-description">
				{{ constants.EXTERNAL_LINK_MODAL.BODY }}
			</ea-paragraph>
			<div class="external-url bold-text"
				data-cy="survey-external-navigation-modal-institution">
					{{ externalLink }}
			</div>
			<ea-button-container
				[justification]="BUTTON_CONTAINER_JUSTIFICATION.Left"
				[alignment]="BUTTON_CONTAINER_ALIGNMENT.Horizontal">
				<ea-button
					[isSubmit]="true"
					(onClick)="navigateToExternalUrl()"
					[type]="BUTTON_TYPES.Primary"
					name="launchExternalWebsite"
					title="Launch External Website"
					data-cy="survey-external-navigation-modal-continue-button">
					Continue
					<i class="fa fa-external-link" aria-hidden="true"></i>
				</ea-button>
				<ea-button
					[type]="BUTTON_TYPES.Secondary"
					(onClick)="closeModal()"
					class="btn-cancel"
					data-cy="survey-external-navigation-modal-cancel-button">
					Cancel
				</ea-button>
			</ea-button-container>
		</ng-template>
</ea-modal>
